export class FilterSearchModel {
  region: Array<any> = [];
  vehicleType: Array<any> = [];
  make: any;
  model: any = '';
  minYear: any = '';
  maxYear: any = '';
}
